import React from "react";

const Escorpion = ({...r}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 120 120" {...r}>
      <path
        fill="#0250C9"
        d="M103.136 77.631l-10.374-7.867a3.616 3.616 0 00-5.802 2.889v3.658h-3.746a3.847 3.847 0 01-2.415-3.602v-31.02a13.67 13.67 0 00-8.706-12.758 13.654 13.654 0 00-15.036 3.515 13.615 13.615 0 00-15.436-3.34 13.616 13.616 0 00-4.565 3.205 12.358 12.358 0 00-9.278-4.31C20.735 28.001 15 34.143 15 41.69a3.626 3.626 0 003.62 3.482 3.621 3.621 0 003.62-3.482c0-3.557 2.482-6.445 5.538-6.445 3.055 0 5.538 2.888 5.538 6.445v35.402a3.62 3.62 0 003.617 3.619 3.616 3.616 0 003.617-3.62V41.69a6.464 6.464 0 016.459-6.462 6.458 6.458 0 016.46 6.462v35.402a3.62 3.62 0 003.616 3.619 3.616 3.616 0 003.617-3.62V41.69a6.464 6.464 0 016.46-6.462 6.457 6.457 0 016.459 6.462v31.019a10.979 10.979 0 008.267 10.738c.285.067.578.101.87.102h4.236v4.832a3.609 3.609 0 002.005 3.237 3.605 3.605 0 003.797-.354l10.374-7.867a3.629 3.629 0 001.053-4.496 3.628 3.628 0 00-1.053-1.275l-.034.005z"
      ></path>
    </svg>
  );
}

export default Escorpion;